/**
 * BaseView
 *
 * The main view that all others extend from
 *
 * @return {view}
 */

OT.createNS('OT.Search.BaseView');

OT.Search.BaseView = (function() {
    'use strict';

    var vm = Backbone.ViewManager = Backbone.ViewManager || {};

    // a simple Base view
    vm.BaseView = Backbone.View.extend({

        templateData: {},

        additionalData: {},

        // NOTE: override this for calls after the initialize method
        onInitialize: function() {},

        // setting additional attributes after the view has been initialized
        setAttributes: function(obj) {
            var _this = this;

            _.each(obj, function(val, key) {
                _this[key] = val;
            });

            this.onSetAttributes();

            return this;
        },

        // NOTE: override this for calls after the setAttributes method
        onSetAttributes: function() {},

        // NOTE: override this for calls before the render method
        // By default, we set the templateData to be the entire data set from the API
        beforeRender: function() {
            this.templateData = OT.Search.Data.get();
            return this;
        },

        // to render the template on the view
        // checks if the 'onRender' callback exists and calls it
        render: function(templateData) {
            if(!this.beforeRender()) {
                return false;
            }

            this.templateData = templateData || this.templateData;

            if (this.template) {
                this.$el.empty().html(OT.Search.Helpers.renderTemplate(this.template, this.templateData, this.additionalData));
            }

            this.templateData = null;
            this.additionalData = null;

            this.onRender();

            return this;
        },

        // NOTE: override this for calls after the render method
        onRender: function() {
            OT.Redesign.Views.TableCategories();
        },

        // clean up before removing the view
        unset: function() {
            // turn off all bindings on the view
            this.stopListening();

            this.onUnset();
        },

        // NOTE: override this for calls after the unset method
        onUnset: function() {},

        unsetView: function() {
            // unset the view
            this.unset();

            // hide the element
            this.$el.hide();

            // empty the element
            this.$el.empty();
        },

        // clean up before removing the view
        destroy: function() {
            this.unset();
            this.unsetView();
            this.undelegateEvents();

            // remove self from the page
            this.remove();
        },

        // wrapping window.Resources so it can be mocked easier in test
        getResources: function() {
            return window.Resources;
        }

    });

})();
